"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FREQ_MAP = exports.FREQ_OPTIONS = exports.PaymentFrequencies = void 0;
const DAILY = { label: 'Daily', value: 'daily', numDays: 1 };
const WEEKLY = { label: 'Weekly', value: 'weekly', numDays: 7 };
const SEMIMONTHLY = { label: 'Semi-monthly', value: 'semiMonthly', numDays: 14 };
const MONTHLY = { label: 'Monthly', value: 'monthly', numDays: 30 };
const FREQ_OPTIONS = [
    DAILY,
    WEEKLY,
    SEMIMONTHLY,
    MONTHLY,
];
exports.FREQ_OPTIONS = FREQ_OPTIONS;
const FREQ_MAP = {
    daily: DAILY,
    weekly: WEEKLY,
    semiMonthly: SEMIMONTHLY,
    monthly: MONTHLY,
};
exports.FREQ_MAP = FREQ_MAP;
